import { Col, Row } from "antd";
import React from "react";
import BannerContent from "./BannerContent";
// import FormComponent from "./FormComponent";
import backgroundImage from '../../../../../assets/images/banner.jpg';
const Banner: React.FC<any> = () => {
    return (
        <>
            <section className="heroSection" style={{backgroundImage: `url(${backgroundImage})`,}}>
                <div className="container">
                    <Row className="content_wrapper">
                        <Col span={14}>
                            <BannerContent />
                        </Col>
                        {/* <Col span={10} className="bannerImg">
                            <FormComponent/>
                            <img src={BannerImg} alt="banner_img" />
                        </Col> */}
                    </Row>
                </div>
            </section>
        </>
    );
};

export default Banner;
